import { z } from 'zod';

export const courseListFilterSchema = z.object({
  academicLevelIds: z.string().trim().nonempty().array().optional().catch(undefined),
  curriculumIds: z.string().trim().nonempty().array().optional().catch(undefined),
  countryZoneCodes: z.string().trim().nonempty().array().optional().catch(undefined)
});

export type CourseListFilterSchema = z.infer<typeof courseListFilterSchema>;
